import { notifyError } from "../../toastify/toastify";

export const SA_ALLOWED_SKUS = new Set(
  [
    "17219133l",
    "17286799V",
    "17267555s",
    "17257811d",
    "17216522g",
    "17313288N",
    "17324244I",
    "17560888T",
    "17559333Y",
    "17805277N",
    "17845666y",
    "17131588G",
  ].map((sku) => sku.toLowerCase())
);

export const SA_SKU_UNAVAILABLE_MESSAGE = "غير متوفر بالمخزن";

export const normalizeSku = (sku) =>
  sku ? String(sku).trim().toLowerCase() : "";

export const isSaOrderableSku = (slug, sku) => {
  if (slug !== "sa") return true;
  return SA_ALLOWED_SKUS.has(normalizeSku(sku));
};

export const notifySaSkuUnavailable = () => {
  notifyError(SA_SKU_UNAVAILABLE_MESSAGE);
};

export const guardSaSkuOrder = (slug, sku) => {
  if (isSaOrderableSku(slug, sku)) return true;
  notifySaSkuUnavailable();
  return false;
};
